import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  DATE_FORMAT_MOMENT,
  DATE_TIME_FORMAT_MOMENT,
  REQUIRED_ERR_MSG,
} from "../Helper/Constants";
import CustomerOrderAttachment from "./CustomerOrderAttachment";
import CustomerOrderBillingDetails from "./CustomerOrderBillingDetails";
import GetSvgIcon, {
  GetSvgBuilding,
  GetSvgPerson,
  GetSvgPhone,
} from "../../images/svglist";
import { deliveryEventlog, permissionCheck } from "../Helper/CommonMethods";
import OrderWaybillList from "./OrderWaybillList";
import { CallApiGet, CallApiPost } from "../Helper/serviceApi";
import { initValShipmentDtls } from "./initValShipmentDtls";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import DeliveryEventLog from "./DeliveryEventLog";
import ClaimAddEdit from "../Claim/ClaimAddEdit";
import { Button } from "react-bootstrap";
import ModalConfirmAlert from "../Layout/ModalConfirmAlert";
import {
  OPT_FOR_DOR,
  DLV_ORD_STS,
  CNCL_ORD_STS,
} from "../../ConfigConstants/ConfigConstants";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};

const initModalConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};
const CustomerOrderDetails = ({
  cancelShipment,

  handelRtsClick,
  handelRepeatBooking,
  conformCancel,
}) => {
  // const SHOW_CANCEL_SHIPMENT_STS = 76;
  // const SHOW_TRANSIT_SHIPMENT_STS = 80;
  // const printAllWaybill = () => {
  //   const waybillData = {
  //     waybill_no: waybillList.map((item) => item.waybillNo),
  //     shipmentId: shipmentDtls?.shipmentId,
  //   };
  //   printWaybill(waybillData);
  // };
  const [dispAddress, setDispAddress] = useState(true);
  const [dispLodgin, setDispLodgin] = useState(true);
  const [dispSCollect, setDispSCollect] = useState(true);
  const [shipmentDtls, setShipmentDtls] = useState(
    JSON.parse(JSON.stringify(initValShipmentDtls))
  );
  const [waybillList, setWaybillList] = useState([]);
  const [claimId, setClaimId] = useState(0);
  const [claimOrderId, setClaimOrderId] = useState(null);
  const [claimPalletId, setClaimPalletId] = useState(null);
  const [claimDetails, setClaimDetails] = useState(null);
  const [orgDestAddrs, setOrgDestAddrs] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [spinner, setSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [deliveryEventLog, setDeliveryEventLog] = useState();
  const [message, setMessage] = useState(null);
  const [shipId, setShipId] = useState();
  const [insPackages, setInsPackages] = useState(null);
  const navigate = useNavigate();
  const { Buffer } = require("buffer");
  const [isChecked, setIsChecked] = useState(false);
  const [openDorConfig, setOpenDorConfig] = useState(initAlertConfig);
  const [dorRemark, setDorRemark] = useState(false);
  const [reasonDor, setReasonDor] = useState("");

  const [modalConfig, setModalConfig] = useState(initModalConfig);
  const [revertStatOpts, setRevertStatOpts] = useState([]);
  const [revertStatusData, setRevertStatusData] = useState([]);
  const [reasonRevertStatus, setReasonRevertStatus] = useState("");
  const [revertReason, setRevertReason] = useState(false);
  let palletData;
  const {
    watch,
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    setError,
    reset,
    trigger,
    control,
    formState: { errors },
  } = useForm();

  const changeToStatus = watch("changeTo");

  useEffect(() => {
    const orderId = searchParams.get("data");
    setShipId(orderId);
    getShipmetDtls("orders", { shipmentId: orderId });
  }, []);

  const resetMessage = () => {
    setTimeout(() => setMessage(""), 50);
  };

  const getShipmetDtls = async (type, shipmentData) => {
    setSpinner(true);
    let data = await CallApiGet(
      "getShipmentDetailsById/" + shipmentData.shipmentId
    );

    if (data.respCode === 200) {
      data.respData.shipDateDiffInDays = moment(
        data.respData.shipmentDate
      ).diff(moment().format("YYYY-MM-DD"), "days");
      setShipmentDtls(data.respData);
      if (
        !!data?.respData?.shipmentPallets &&
        data.respData.shipmentPallets.length > 0
      ) {
        let waybillArray = data.respData.shipmentPallets.map((item) => {
          return {
            palletId: item.palletId,
            waybillNo: item.waybillNo,
            weight: item.weight,
            width: item.width,
            height: item.height,
            length: item.length,
          };
        });
        if (shipmentData.waybill_no && ["waybill", "claim"].includes(type)) {
          waybillArray = waybillArray.filter(
            (item) => item.waybillNo === shipmentData.waybill_no
          );
        }
        setWaybillList(waybillArray);
        if (type === "claim") {
          setClaimOrderId(data?.respData?.shipmentId);
          setClaimPalletId(waybillArray[0].palletId);
        }
      }
      getOriginDestinationAddress(
        data?.respData?.origin?.sbuId,
        data?.respData?.destination?.sbuId
      );
      filterShipmentDtls(data?.respData);
      setInsPackages(
        data?.respData?.insurPkgDtls
          ? JSON.parse(data?.respData?.insurPkgDtls)
          : null
      );
      setSpinner(false);
    } else {
      setSpinner(false);
    }

    // if(insData.respCode === 200){

    //   // setInsPackages(insData.respData.insuranceData)
    //   setInsPackages(insData.respData.insuranceData.filter(a=>a.insuranceId===data.respData.insurancePkgId)[0])
    // }
  };

  const getOriginDestinationAddress = async (originId, destId) => {
    if (originId) {
      let addressDataResp = await CallApiGet(
        "get-org-dest-address?originId=" + originId + "&destId=" + destId
      );

      if (addressDataResp.respCode === 200) {
        setOrgDestAddrs(addressDataResp.respData[0]);
      }
    }
  };
  const reloadShipmentData = () => {
    getShipmetDtls("orders", { shipmentId: shipId });
  };
  const filterShipmentDtls = (shipmentDtls) => {
    if (shipmentDtls?.shipmentVas?.length > 0) {
      let shipmentVasDataList = shipmentDtls?.shipmentVas;
      let slodg = true;
      let scollect = true;
      shipmentVasDataList.forEach((e) => {
        if (e.serviceId === 9) {
          slodg = false;
          setDispLodgin(false);
        } else if (e.serviceId === 148) {
          scollect = false;
          setDispSCollect(false);
        }
      });
      // console.log(shipmentVasDataList);
      setDispAddress(scollect || slodg ? true : false);
      setDispAddress(true);
    } else {
      setDispAddress(true);
      if (shipmentDtls.orderTypeCode === "FTL") {
        setDispSCollect(false);
        setDispLodgin(false);
      }
    }
  };
  const hideAlert = () => {
    setAlertConfig({
      isSuccess: alertConfig.isSuccess,
      size: alertConfig.size,
      show: false,
      title: "",
      description: "",
    });
    getShipmetDtls("orders", { shipmentId: searchParams.get("data") });
  };

  const showAlert = (data) => {
    setAlertConfig({
      isSuccess: data.isSuccess,
      size: "md",
      show: true,
      title: data.title,
      description: data.description,
    });
  };

  const getDeliveryEventLog = async (wb) => {
    document.body.click();
    setSpinner(true);
    let deliveryEventLogData = await deliveryEventlog(wb);
    setSpinner(false);
    if (deliveryEventLogData.respCode === 200) {
      let data = deliveryEventLogData.respData;
      setDeliveryEventLog(data);
    } else if (deliveryEventLogData.respCode === 500) {
      showAlert({
        isSuccess: false,
        title: "",
        description: deliveryEventLogData.respMessage,
      });
    } else {
      setDeliveryEventLog([]);
      localStorage.clear();
      navigate("/home");
    }
  };

  // const showClaimForm = (data) => {
  //   if (!data.hasOwnProperty("shipmentId") || !data.shipmentId) {
  //     data["shipmentId"] = data?.orderId;
  //     delete data["shipmentid"];
  //   }
  //   document.body.click();
  //   getShipmetDtls("claim", data);
  // };

  const showClaimForm = (argData) => {
    let encoded = Buffer.from(
      JSON.stringify({
        claimId: 0,
        orderId: argData?.orderId,
        palletId: argData?.palletId,
        waybillNo: argData?.waybillNo,
      })
    ).toString("base64");
    //window.open(`/raiseClaim?data=${encoded}`, "_blank");
    navigate(`/raiseClaim?data=${encoded}`);
  };
  const cancelClaimForm = () => {
    setClaimOrderId(null);
    setClaimPalletId(null);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const openDorModalConfig = async () => {
    setOpenDorConfig({
      isSuccess: false,
      size: "",
      show: true,
      title: "DOR",
      description: "",
    });
    setDorRemark(false);
    setReasonDor(null);
  };

  const closeDorModalConfig = async () => {
    setOpenDorConfig({
      isSuccess: false,
      size: "",
      show: false,
      title: "",
      description: "",
    });
  };

  const handleDorSubmit = async (data) => {
    const remark = document.getElementById("dor-remark").value.trim();
    setDorRemark(!remark);
    if (!remark) {
      return;
    }
    setSpinner(true);
    const payload = {
      orderId: shipId,
      latitude: 0,
      longitude: 0,
      remarks: remark,
    };
    const resp = await CallApiPost("optForDOR", payload);
    handleApiResponse(resp);
    setIsChecked(false);
    setDorRemark(false);
    setReasonDor(null);
    setSpinner(false);
    closeDorModalConfig();
  };

  const handleApiResponse = (resp) => {
    switch (resp.respCode) {
      case 200:
        openPopup(true, "SUCCESS", resp.respMessage);
        break;
      case 500:
        openPopup(
          false,
          "ERROR",
          "Something went wrong. Please try after sometime!!"
        );
        break;
      case 99:
        openPopup(false, "ERROR", "Network Error!!");
        break;
      default:
        openPopup(false, "ERROR", resp.respMessage);
        break;
    }
  };

  const openPopup = (boolVal, argTitle, argDesc) => {
    setAlertConfig({
      isSuccess: boolVal,
      size: "",
      show: true,
      title: argTitle,
      description: argDesc,
    });
  };

  const setRemark = (e) => {
    setReasonDor(e.target.value);
    setDorRemark(false);
  };

  const statusReverseConfig = async () => {
    setSpinner(true);
    const resp = await CallApiGet(
      "statusReversionConfig/" + palletData?.palletDeliveryStatus
    );
    if (resp.respCode === 200) {
      let res = resp.respData.map((a) => ({
        label: a.status_value,
        value: a.status_id,
      }));
      setRevertStatOpts(res);
    }
    setSpinner(false);
  };
  const revertWaybillStatus = async () => {
    const reasonRevertStatus = document
      .getElementById("revert-reason")
      .value.trim();
    let isReasonValid = !!reasonRevertStatus;
    let isChangeToValid = !!changeToStatus || changeToStatus === 0;

    // Update validation states
    setRevertReason(!isReasonValid);

    if (!isChangeToValid) {
      setError("changeTo", {
        type: "custom",
        message: REQUIRED_ERR_MSG,
      });
    } else {
      clearErrors("changeTo");
    }

    // Stop if any validation failed
    if (!isReasonValid || !isChangeToValid) {
      return;
    }

    document.body.click();
    setSpinner(true);
    let payload = {
      palletId: revertStatusData.palletId,
      fromStatus: revertStatusData.palletDeliveryStatus,
      toStatus: changeToStatus,
      remarks: reasonRevertStatus,
    };
    let response = await CallApiPost("revertWaybillStatus", payload);
    closeModalconfig();
    setSpinner(false);
    if (response.respCode === 200) {
      showAlert({
        isSuccess: true,
        title: "SUCCESS",
        description: "Waybill status successfully reverted!!",
      });
    } else if (response.respCode === 500) {
      showAlert({
        isSuccess: false,
        title: "ERROR",
        description: "Something went wrong. Please try after sometime!!",
      });
    } else if (response.respCode === 400) {
      showAlert({
        isSuccess: false,
        title: "ERROR",
        description: response.resetMessage,
      });
    } else {
      localStorage.clear();
      navigate("/home");
    }
    setReasonRevertStatus("");
  };

  const revertWebStatus = (row) => {
    setRevertStatusData(row);
    palletData = row;
    setModalConfig({
      isSuccess: false,
      size: "md",
      show: true,
      title: "Revert Status",
      description: "",
    });
    statusReverseConfig();
    setReasonRevertStatus(null);
    setRevertReason(false);
  };

  const closeModalconfig = () => {
    setModalConfig({
      isSuccess: false,
      size: "md",
      show: false,
      title: "Revert Webill Status",
      description: "",
    });
    setReasonRevertStatus(null);
    setRevertReason(false);
    reset();
  };

  const setRevertRemark = (e) => {
    setReasonRevertStatus(e.target.value);
    setRevertReason(false);
  };

  const handleChange = () => {
    clearErrors("changeTo");
  };

  return (
    <>
      <Layout
        spinnershow={spinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
      >
        {!!message && (
          <div id="errorMsg" className="alert alert-danger" role="alert">
            {message}
          </div>
        )}
        <div className="row mt-3">
          <div className="col-xxl-8 col-lg-9 col-md-12">
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Order Details
              </div>
              <div className="p-2">
                <div className="d-flex justify-content-between align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Order Number</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls?.orderNo}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Booking Date</div>
                    <div className="theme-blue-txt">
                      {moment(shipmentDtls?.bookedOn).format(
                        DATE_TIME_FORMAT_MOMENT
                      )}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Shipment Date</div>
                    <div className="theme-blue-txt">
                      {moment(shipmentDtls?.shipmentDate).format(
                        DATE_FORMAT_MOMENT
                      )}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Estimated Delivery Date</div>
                    <div className="theme-blue-txt">
                      {moment(shipmentDtls?.estDeliveryDate).format(
                        DATE_FORMAT_MOMENT
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-start align-item-center">
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Origin</div>
                    <div className="theme-blue-txt">
                      <span className="text-info">
                        {GetSvgIcon("BiGeoAltFillDanger")}
                      </span>{" "}
                      {shipmentDtls.origin.sbuCode}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Destination</div>
                    <div className="theme-blue-txt">
                      <span className="text-success">
                        {GetSvgIcon("BiGeoAltFillSuccess")}
                      </span>{" "}
                      {shipmentDtls.destination.sbuCode}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Content Type</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls.packingType !== "null"
                        ? shipmentDtls.packingType
                        : ""}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Content Description</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls.packageDesc !== "null"
                        ? shipmentDtls.packageDesc
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-start align-item-center">
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Service Name</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls.slaName !== "null"
                        ? shipmentDtls.slaName
                        : "N/A"}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Pallets</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls?.pallets}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Booked Pallet Space</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls.initPalletSpace !== "null"
                        ? shipmentDtls.initPalletSpace
                        : "N/A"}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Actual Pallet Space</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls.palletSpaceRequired !== "null"
                        ? shipmentDtls.palletSpaceRequired
                        : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-start align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Value Added Services</div>
                    <div>
                      {shipmentDtls.shipmentVas.map((vas) => (
                        <span className="theme-blue-txt">
                          {vas.serviceId === 10
                            ? "Packaging : " + vas.pallets + " pallet(s) "
                            : vas.serviceId === 149 && vas.svcInfo1 === "P"
                            ? "Pickup Handling : " + vas.pallets + " pallet(s) "
                            : vas.serviceId === 149 && vas.svcInfo1 === "D"
                            ? "Delivery Handling : " +
                              vas.pallets +
                              " pallet(s) "
                            : ""}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Delivery Order Return</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls.doReturn === true ? "Yes" : "No"}
                    </div>
                    {shipmentDtls.doReturn !== true &&
                      shipmentDtls.status !== DLV_ORD_STS &&
                      shipmentDtls.status !== CNCL_ORD_STS &&
                      permissionCheck(OPT_FOR_DOR, "allowedWrite") && (
                        <div className="flex items-center gap-3">
                          <input
                            type="checkbox"
                            id="dorCheck"
                            className="form-check-input"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                          <span> Opt for DOR?</span>&emsp;
                          {isChecked && (
                            <button
                              type="button"
                              className="btn btn-outline-secondary theme-violet"
                              style={{
                                padding: "4px 8px",
                                transform: "scale(0.9)",
                              }}
                              onClick={openDorModalConfig}
                            >
                              {GetSvgIcon("IconDOR")}
                            </button>
                          )}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            {!!insPackages && (
              <div className="bg-white border border-2 rounded-2 mb-3">
                <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                  Protection Info
                </div>
                <div className="p-2">
                  <div className="d-flex justify-content-between align-item-center">
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Package Id</div>
                      <div className="theme-blue-txt">
                        {insPackages !== null ? insPackages.package_id : "N/A"}
                      </div>
                    </div>
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Coverage Upto</div>
                      <div className="theme-blue-txt">
                        {insPackages !== null
                          ? "RM " + insPackages.coverage
                          : "N/A"}
                      </div>
                    </div>
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Insurance Fee</div>
                      <div className="theme-blue-txt">
                        {insPackages !== null
                          ? "RM " + insPackages.charge
                          : "N/A"}
                      </div>
                    </div>
                    <div className="col-3 grd-bg p-2 p my-2 rounded-3">
                      <div className="fw-bold">Insurance Declared Price</div>
                      <div className="theme-blue-txt">
                        {shipmentDtls.insDeclaredPrice !== "null"
                          ? "RM " + shipmentDtls.insDeclaredPrice
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="bg-white border border-2 rounded-2 mb-3">
              <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                Customer Details
              </div>
              <div className="p-2">
                <div className="d-flex justify-content-between align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Customer Name</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls?.customerDtls?.custName}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Account Number</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls?.customerDtls?.accountCode}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Phone</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls?.customerDtls?.custPhone}
                    </div>
                  </div>
                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="fw-bold">Address</div>
                    <div className="theme-blue-txt">
                      {shipmentDtls?.customerDtls?.custAddr +
                        "," +
                        shipmentDtls?.customerDtls?.custCity +
                        "," +
                        shipmentDtls?.customerDtls?.custState +
                        "," +
                        shipmentDtls?.customerDtls?.custPostCode}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {dispAddress && (
              <div className="bg-white border border-2 rounded-2 mb-3">
                <div className="tab-panel-heading fw-bold p-2 font-18 rounded-top border-3">
                  Address
                </div>

                <div className="d-flex justify-content-between align-item-center">
                  <div className="col grd-bg p-2 p my-2 rounded-3 ms-2">
                    <div className="col">
                      <div className="fw-bold">Sender Address:</div>
                      <div className="theme-blue-txt">
                        <span className="theme-blue-txt me-2">
                          {GetSvgPerson(false)}
                        </span>
                        {shipmentDtls?.senderAddress?.name}
                      </div>
                      <div className="theme-blue-txt font-12 mt-2">
                        <span className="theme-blue-txt me-2">
                          {GetSvgPhone(false)}
                        </span>
                        {shipmentDtls?.senderAddress?.phone?.substr(0, 3) +
                          "-" +
                          shipmentDtls?.senderAddress?.phone?.substr(3)}
                      </div>
                      <div className="theme-blue-txt d-flex font-12 mt-2">
                        <span className="theme-blue-txt me-2">
                          {GetSvgBuilding(false)}
                        </span>
                        <div className="font-12">
                          {shipmentDtls?.senderAddress?.address +
                            ", " +
                            shipmentDtls?.senderAddress?.city +
                            ", " +
                            shipmentDtls?.senderAddress?.state +
                            ", " +
                            shipmentDtls?.senderAddress?.postcode}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col grd-bg p-2 p my-2 rounded-3">
                    <div className="col">
                      <div className="fw-bold">Recipient Address:</div>
                      <div className="theme-blue-txt">
                        <span className="theme-blue-txt me-2">
                          {GetSvgPerson(false)}
                        </span>
                        {shipmentDtls?.recipientAddress?.name}
                      </div>
                      <div className="theme-blue-txt font-12 mt-2">
                        <span className="theme-blue-txt  me-2">
                          {GetSvgPhone(false)}
                        </span>{" "}
                        {shipmentDtls?.recipientAddress?.phone?.substr(0, 3) +
                          "-" +
                          shipmentDtls?.recipientAddress?.phone?.substr(3)}
                      </div>
                      <div className="theme-blue-txt d-flex font-12 mt-2">
                        <span className="theme-blue-txt me-2">
                          {GetSvgBuilding(false)}
                        </span>
                        <div className="font-12">
                          {shipmentDtls?.recipientAddress?.address +
                            ", " +
                            shipmentDtls?.recipientAddress?.city +
                            ", " +
                            shipmentDtls?.recipientAddress?.state +
                            ", " +
                            shipmentDtls?.recipientAddress?.postcode}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-item-center">
                  {dispLodgin === true ? (
                    <div className="col grd-bg p-2 p my-2 rounded-3 ms-2">
                      <div className="col">
                        <div className="fw-bold">Lodge in Address:</div>
                        <div className="theme-blue-txt">
                          <span className="theme-blue-txt me-2">
                            {GetSvgIcon("LocPin")}
                          </span>
                          {orgDestAddrs?.origingName}
                        </div>
                        <div className="theme-blue-txt font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgPhone(false)}
                          </span>{" "}
                          {orgDestAddrs?.origingPhone?.substr(0, 3) +
                            "-" +
                            orgDestAddrs?.origingPhone?.substr(3)}
                        </div>
                        <div className="theme-blue-txt d-flex font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgBuilding(false)}
                          </span>
                          <div className="font-12">
                            {orgDestAddrs?.origingAddress +
                              ", " +
                              orgDestAddrs?.origingCity +
                              ", " +
                              orgDestAddrs?.origingState +
                              ", " +
                              orgDestAddrs?.originPostCode}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col grd-bg p-2 p my-2 rounded-3 ms-2">
                      <div className="col">
                        <div className="fw-bold">Pickup Address:</div>
                        <div className="theme-blue-txt">
                          <span className="theme-blue-txt me-2">
                            {GetSvgPerson(false)}
                          </span>
                          {shipmentDtls?.pickupAddress?.name}
                        </div>
                        <div className="theme-blue-txt font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgPhone(false)}
                          </span>
                          {shipmentDtls?.pickupAddress?.phone?.substr(0, 3) +
                            "-" +
                            shipmentDtls?.pickupAddress?.phone?.substr(3)}
                        </div>
                        <div className="theme-blue-txt d-flex font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgBuilding(false)}
                          </span>
                          <div className="font-12">
                            {shipmentDtls?.pickupAddress?.address +
                              ", " +
                              shipmentDtls?.pickupAddress?.city +
                              ", " +
                              shipmentDtls?.pickupAddress?.state +
                              ", " +
                              shipmentDtls?.pickupAddress?.postcode}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {dispSCollect === true ? (
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="col">
                        <div className="fw-bold">Self Collect Address:</div>
                        <div className="theme-blue-txt">
                          <span className="theme-blue-txt me-2">
                            {GetSvgIcon("LocPin")}
                          </span>
                          {orgDestAddrs?.destinationName}
                        </div>
                        <div className="theme-blue-txt font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgPhone(false)}
                          </span>{" "}
                          {orgDestAddrs?.destinationPhone?.substr(0, 3) +
                            "-" +
                            orgDestAddrs?.destinationPhone?.substr(3)}
                        </div>
                        <div className="theme-blue-txt d-flex font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgBuilding(false)}
                          </span>
                          <div className="font-12">
                            {orgDestAddrs?.destinationAddress +
                              ", " +
                              orgDestAddrs?.destinationCity +
                              ", " +
                              orgDestAddrs?.destinationState +
                              ", " +
                              orgDestAddrs?.destinationPostCode}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col grd-bg p-2 p my-2 rounded-3">
                      <div className="col">
                        <div className="fw-bold">Delivery Address:</div>
                        <div className="theme-blue-txt">
                          <span className="theme-blue-txt me-2">
                            {GetSvgPerson(false)}
                          </span>
                          {shipmentDtls?.deliveryAddress?.name}
                        </div>
                        <div className="theme-blue-txt font-12 mt-2">
                          <span className="theme-blue-txt  me-2">
                            {GetSvgPhone(false)}
                          </span>{" "}
                          {shipmentDtls?.deliveryAddress?.phone?.substr(0, 3) +
                            "-" +
                            shipmentDtls?.deliveryAddress?.phone?.substr(3)}
                        </div>
                        <div className="theme-blue-txt d-flex font-12 mt-2">
                          <span className="theme-blue-txt me-2">
                            {GetSvgBuilding(false)}
                          </span>
                          <div className="font-12">
                            {shipmentDtls?.deliveryAddress?.address +
                              ", " +
                              shipmentDtls?.deliveryAddress?.city +
                              ", " +
                              shipmentDtls?.deliveryAddress?.state +
                              ", " +
                              shipmentDtls?.deliveryAddress?.postcode}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {!!shipmentDtls &&
              !!shipmentDtls?.shipmentId &&
              shipmentDtls?.shipmentId !== "" && (
                <>
                  <CustomerOrderAttachment
                    shipmentDtls={shipmentDtls}
                    setSpinner={setSpinner}
                    reloadShipmentData={reloadShipmentData}
                    message={message}
                    setMessage={setMessage}
                    resetMessage={resetMessage}
                    showAlert={showAlert}
                  />
                </>
              )}
            {!!shipmentDtls &&
              !!shipmentDtls?.shipmentId &&
              shipmentDtls?.shipmentId !== "" && (
                <>
                  <OrderWaybillList
                    shipmentPallets={shipmentDtls?.shipmentPallets}
                    showClaimForm={showClaimForm}
                    getDeliveryEventLog={getDeliveryEventLog}
                    orderStatus={shipmentDtls.status}
                    setSpinner={setSpinner}
                    revertWebStatus={revertWebStatus}
                  />
                </>
              )}
          </div>
          {!!shipmentDtls &&
            !!shipmentDtls?.shipmentId &&
            shipmentDtls?.shipmentId !== "" &&
            shipmentDtls.shipmentBilling.length > 0 && (
              <div className="col-xxl-4 col-lg-3 col-md-12">
                <CustomerOrderBillingDetails
                  billingDetails={shipmentDtls.shipmentBilling}
                  orderData={shipmentDtls}
                />
              </div>
            )}
        </div>
        <DeliveryEventLog data={deliveryEventLog} />
      </Layout>
      {!!claimOrderId && !!claimPalletId && (
        <ClaimAddEdit
          claimId={claimId}
          claimDetails={claimDetails}
          claimOrderId={claimOrderId}
          claimPalletId={claimPalletId}
          cancelClaimForm={cancelClaimForm}
          showAlert={showAlert}
          setSpinner={setSpinner}
        />
      )}

      <ModalConfirmAlert
        confirmAlertConfig={modalConfig}
        hideConfirmAlert={closeModalconfig}
        confirmAlert={revertWaybillStatus}
      >
        <div className="row d-flex justify-content-between text-left">
          <div className="col-md-6">
            <div>
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Current Status
              </label>
            </div>
            <input
              type="text"
              className="form-control"
              aria-label="Disabled input example"
              value={revertStatusData?.palletDeliveryStatusText}
              disabled
            />
          </div>
          <div className="col-md-6 ms-auto">
            <label
              htmlFor="floatingInputGrid"
              className="form-label theme-label"
            >
              Change To
              <span className="text-danger">&#9733;</span>
            </label>
            <Controller
              name="changeTo"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: REQUIRED_ERR_MSG,
                },
              }}
              render={({ field: { onChange, value } }) => (
                <Select
                  placeholder="Select Status"
                  isSearchable={true}
                  isClearable={true}
                  className="form-control p-0"
                  options={revertStatOpts}
                  value={revertStatOpts.find((opt) => opt.value === value)}
                  onChange={(e) => {
                    onChange(e ? e.value : "");
                    handleChange();
                  }}
                />
              )}
            />
            {errors.changeTo && (
              <div>
                <span className="badge bg-danger">
                  &#9888; {errors?.changeTo?.message}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="row mt-2 text-left">
          <div className="col-md-3">
            <label
              htmlFor="floatingInputGrid"
              className="form-label theme-label"
            >
              Reason <span className="text-danger">&#9733;</span>
            </label>
          </div>
          <div className="col-md-9 mb-2">
            <input
              id="revert-reason"
              type="text"
              className="form-control"
              name="reasonRevertStatus"
              value={reasonRevertStatus}
              autoComplete="false"
              onChange={(e) => setRevertRemark(e)}
            />
            {revertReason && (
              <div style={{ textAlign: "left" }}>
                <span className="badge bg-danger">
                  &#9888; This field is required.
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="row mt-2 text-left">
          <div className="col-md-3">
            <label htmlFor="floatingInputGrid" className="form-label">
              Note:
            </label>
          </div>
          <div className="col-md-9 mb-2">
            <p>
              You may lose some of the delivery event log informations if you
              change the status.
            </p>
          </div>
        </div>
      </ModalConfirmAlert>

      <ModalConfirmAlert
        confirmAlertConfig={openDorConfig}
        hideConfirmAlert={closeDorModalConfig}
        confirmAlert={handleDorSubmit}
      >
        <div className="row">
          <div className="col-md-3">
            <label
              htmlFor="floatingInputGrid"
              className="form-label theme-label"
            >
              Remark <span className="text-danger">&#9733;</span>
            </label>
          </div>
          <div className="col-md-9 mb-2">
            <input
              id="dor-remark"
              type="text"
              className="form-control"
              name="dorRemark"
              value={reasonDor}
              autoComplete="false"
              onChange={(e) => setRemark(e)}
            />
            {dorRemark && (
              <div style={{ textAlign: "left" }}>
                <span className="badge bg-danger">
                  &#9888; This field is required.
                </span>
              </div>
            )}
          </div>
        </div>
      </ModalConfirmAlert>
    </>
  );
};

export default CustomerOrderDetails;
